import * as React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const Cash = ({ size = 36, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} fill="#fff" />
    <Path
      d="M27.406 26.136H8.596a1.463 1.463 0 0 1-1.463-1.463V14.521c0-.808.655-1.463 1.463-1.463h18.81c.808 0 1.463.655 1.463 1.463v10.152c0 .808-.655 1.463-1.463 1.463Z"
      fill="#5E76A6"
    />
    <Path
      d="M27.406 25.04H8.596a1.463 1.463 0 0 1-1.463-1.462V13.425c0-.808.655-1.463 1.463-1.463h18.81c.808 0 1.463.655 1.463 1.463v10.152c0 .808-.655 1.464-1.463 1.464Z"
      fill="#D1D9E9"
    />
    <Path
      d="M27.406 23.945H8.596a1.463 1.463 0 0 1-1.463-1.463V12.329c0-.808.655-1.463 1.463-1.463h18.81c.808 0 1.463.655 1.463 1.463v10.153c0 .808-.655 1.463-1.463 1.463Z"
      fill="#5E76A6"
    />
    <Path
      d="M27.406 22.85H8.596a1.463 1.463 0 0 1-1.463-1.464V11.234c0-.808.655-1.463 1.463-1.463h18.81c.808 0 1.463.655 1.463 1.463v10.152c0 .808-.655 1.463-1.463 1.463Z"
      fill="#9AACD0"
    />
    <Path
      d="M10.18 22.847H8.595a1.462 1.462 0 0 1-1.462-1.462V11.232c0-.806.656-1.462 1.462-1.462h1.585c-.806 0-1.462.656-1.462 1.462v10.153c0 .81.656 1.462 1.462 1.462Z"
      fill="#9AACD0"
    />
    <Path
      d="M27.276 13.558v5.501a2.376 2.376 0 0 0-2.379 2.38H11.101a2.375 2.375 0 0 0-2.374-2.38v-5.501a2.373 2.373 0 0 0 2.374-2.374h13.796a2.375 2.375 0 0 0 2.38 2.374Z"
      fill="#EAF1FF"
    />
    <Path
      d="M11.206 16.974a.893.893 0 1 0 0-1.787.893.893 0 0 0 0 1.787ZM24.796 16.974a.893.893 0 1 0 0-1.787.893.893 0 0 0 0 1.787Z"
      fill="#869AC3"
    />
    <Path
      d="M18.013 20.383a4.115 4.115 0 1 0 0-8.23 4.115 4.115 0 0 0 0 8.23Z"
      fill="#fff"
    />
    <Path
      d="M18.652 14.381c.111.154.178.309.218.476.003.013.036.027.055.027.17.002.34.001.51.002.118 0 .15.032.151.149v.301c-.001.095-.039.132-.135.132h-.516c-.03 0-.05.002-.058.04-.104.542-.439.882-.947 1.062-.144.05-.296.077-.448.116.004.005.01.017.02.026.54.587 1.048 1.202 1.553 1.82.016.019.033.04.041.063.024.068-.032.14-.11.141-.226.002-.453 0-.68.001-.046 0-.077-.024-.106-.058-.434-.507-.868-1.014-1.305-1.52-.132-.153-.272-.3-.41-.449a.16.16 0 0 1-.047-.117v-.401c0-.096.041-.135.139-.136.163 0 .326.003.488-.003.229-.008.451-.048.653-.165a.67.67 0 0 0 .32-.395v-.024H16.591c-.122 0-.153-.03-.153-.152v-.296c0-.1.036-.135.137-.135H18c-.034-.048-.056-.085-.084-.117a.757.757 0 0 0-.5-.247c-.198-.023-.398-.023-.597-.031-.08-.003-.16 0-.241 0-.102-.001-.14-.04-.14-.14v-.41c0-.108.032-.142.14-.142h2.86c.106 0 .14.035.14.142v.302c0 .102-.036.138-.14.138H18.652Z"
      fill="#3F5583"
    />
    <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} stroke="#D1D9E9" />
  </Svg>
)

export default Cash
